import axios from 'axios'

export default function useLegacy() {
  const isLegacyCustomerBirthdayActive = ref(false)
  const isLegacyCustomerVipActive = ref(false)
  const isLegacyCustomerAtRiskActive = ref(false)

  const fetchAutopilotLegacy = async () => {
    const { data } = await axios.get('/autopilots')
    data.data.forEach((autopilot) => {
      if (autopilot.trigger === 'CustomerBirthday' && autopilot.isActive) {
        isLegacyCustomerBirthdayActive.value = true
      }
      if (autopilot.trigger === 'CustomerVip' && autopilot.isActive) {
        isLegacyCustomerVipActive.value = true
      }
      if (autopilot.trigger === 'CustomerAtRisk' && autopilot.isActive) {
        isLegacyCustomerAtRiskActive.value = true
      }
    })
  }

  onMounted(async () => {
    await fetchAutopilotLegacy()
  })

  return {
    isLegacyCustomerBirthdayActive,
    isLegacyCustomerVipActive,
    isLegacyCustomerAtRiskActive
  }
}
